// extracted by mini-css-extract-plugin
export var brand = "_9w-9";
export var compact = "_9w-6";
export var extraSmall = "_9w-7";
export var icon = "_9w-0";
export var large = "_9w-4";
export var light = "_9w-1";
export var medium = "_9w-5";
export var outline = "_9w-b";
export var primaryDark = "_9w-a";
export var primaryLight = "_9w-8";
export var primaryModern = "_9w-c";
export var success = "_9w-2";
export var successSolid = "_9w-3";